import * as Action from '../js/actionTypes';

const DEFAULT_AUTH = {
  authState: '',

  currentUser: {
    cognitoUser: null,

    username: "",
    email: "",
    role: "",
    homepage: "/",
    org: "",

    jwtToken: ""
  }
};

export default function authReducer(state = DEFAULT_AUTH, action) {
  switch(action.type) {
    case Action.UPDATE_AUTH_STATE:
      return { ...state, authState: action.authState };

    case Action.UPDATE_CURRENT_USER:
      return { ...state, currentUser: action.user };

    default:
      return state;
  }
}
